import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import './Login.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetLoading, setResetLoading] = useState(false);
  const [resetMessage, setResetMessage] = useState('');
  const [resetError, setResetError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    
    if (result.success) {
      navigate('/');
    } else {
      setError(result.message || 'Login failed');
    }
    
    setLoading(false);
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setResetError('');
    setResetMessage('');
    setResetLoading(true);

    try {
      const response = await axios.post(`${API_URL}/auth/reset-password`, { email: resetEmail });
      if (response.data.success) {
        setResetMessage('Password has been reset successfully! Please check your inbox for the new password.');
        setResetEmail('');
      }
    } catch (error) {
      setResetError(error.response?.data?.message || 'Failed to reset password. Please try again.');
    }

    setResetLoading(false);
  };

  const toggleResetPassword = () => {
    setShowResetPassword(!showResetPassword);
    setResetError('');
    setResetMessage('');
    setResetEmail('');
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img width="50" height="60" src="/logo-small.svg" class="custom-logo" alt="Teacup Tech Systems" decoding="async" />
          <h1>TeaTime Dashboard</h1>
          <p>{showResetPassword ? 'Reset your password' : 'Sign in to your account'}</p>
        </div>

        {!showResetPassword ? (
          <>
            <form onSubmit={handleSubmit} className="login-form">
              {error && <div className="error-message">{error}</div>}
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="Enter your email"
                />
              </div>
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="Enter your password"
                />
              </div>
              <button type="submit" className="login-button" disabled={loading}>
                {loading ? 'Signing in...' : 'Sign In'}
              </button>
            </form>
            <div className="forgot-password-link">
              <button type="button" onClick={toggleResetPassword} className="link-button">
                Forgot Password?
              </button>
            </div>
          </>
        ) : (
          <>
            <form onSubmit={handleResetPassword} className="login-form">
              {resetError && <div className="error-message">{resetError}</div>}
              {resetMessage && <div className="success-message">{resetMessage}</div>}
              <div className="form-group">
                <label htmlFor="resetEmail">Email Address</label>
                <input
                  type="email"
                  id="resetEmail"
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)}
                  required
                  placeholder="Enter your email address"
                />
              </div>
              <button type="submit" className="login-button reset-button" disabled={resetLoading}>
                {resetLoading ? 'Sending...' : 'Reset Password'}
              </button>
            </form>
            <div className="forgot-password-link">
              <button type="button" onClick={toggleResetPassword} className="link-button">
                ← Back to Sign In
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Login;

